import api from "api";

const orders = {
    get: (params) => {
        let customParams = params.status === 'all' ? {...params, status: ''} : {...params}
        return api().get('/orders', { params: { ...customParams } });
    },

    detail: (id) => {
        return api().get(`/orders/detail/${id}`);
    },

    advanceOrderFulfillmentStatus: (orderId) => {
        return api().post(`/orders/${orderId}/fulfillment-status/advance`);
    },

    updateOrderFulfillmentStatus: (orderId, status) => {
        return api().patch(`/orders/${orderId}/fulfillment-status`, {
            status,
        });
    },

    producerRefund: (orderId) => {
        return api().post(`/orders/${orderId}/producer-refund`);
    },

    // Pedido de estorno do comprador (carteira): situação da compra e o pedido em si.
    // Situação: { can_request, mode ('direct' no prazo do consumidor, 'request' fora dele),
    // within_consumer_right, can_cancel, blocked_code, blocked_reason, deadline, window, request }.
    refundRequestStatus: (orderId) => {
        return api().get(`/orders/${orderId}/refund-request`);
    },

    // { reason, details } — reason: cant_attend | event_changed | bought_by_mistake | duplicate | other.
    // Dentro do prazo do consumidor estorna na hora (resposta já `approved`); fora dele vai ao produtor (`pending`).
    requestRefund: (orderId, payload) => {
        return api().post(`/orders/${orderId}/refund-request`, payload);
    },

    // O comprador desiste do pedido que fez ao produtor, enquanto ele não respondeu.
    cancelRefundRequest: (refundRequestId) => {
        return api().post(`/orders/refund-requests/${refundRequestId}/cancel`);
    },

    // O produtor responde ao pedido do comprador: aceitar estorna; recusar exige o motivo (`answer`).
    approveRefundRequest: (refundRequestId) => {
        return api().post(`/orders/refund-requests/${refundRequestId}/producer-approve`);
    },

    denyRefundRequest: (refundRequestId, answer) => {
        return api().post(`/orders/refund-requests/${refundRequestId}/producer-deny`, { answer });
    },

    // Cotação do pedido pendente: a taxa de serviço é calculada só pelo backend,
    // uma vez por pedido. { subtotal, discount, absorbs_service_fee,
    // payment_methods: { pix|credit_card: { service_fee, total } } }.
    // Só responde com o pedido pendente e dentro da reserva: chame depois do POST /orders.
    quote: (orderId) => {
        return api().get(`/orders/${orderId}/quote`);
    },

    // Pedidos de estorno dos eventos do produtor. `status`: pending (padrão, os mais antigos
    // primeiro) | answered. `meta.pending_count` e `meta.oldest_pending_at` vêm sempre.
    producerRefundRequests: (params = {}) => {
        return api().get('/orders/refund-requests/producer', { params });
    },

    getInstallments: (orderId, paymentMethod) => {
        return api().get(`/orders/${orderId}/installments?payment_method=${paymentMethod}`);
    },
}

export default orders;